<template>
  <div class="item-box-content">
    <div class="title-font-style">
      <span>合同生成区</span>
    </div>
    <div style="matgin-top:30px;" v-for="(item, index) in data" :key="index">
      <div class="solid" style="margin:30px 0 0 0;"></div>
      <el-form  style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8" >
              <el-form-item label="合同编号：">
                <span class="approval">{{ item.pcbNumber }}</span>
                 <el-button style="margin-left:20px" @click="createContract(item)" type="primary" plain>进入</el-button>
              </el-form-item>

          </el-col>
          <el-col :span="8">
            <el-form-item label="合同状态：">
              {{
              dataList[item.contractState-1]
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="生成时间：">
              {{
              item.riseTime | dateFilter
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item  label="供应商名称："><span class="approval" @click="supplierName(item.suId)">{{ item.suName }}</span></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="供应商类型：">{{ status[item.suType-1] }}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="贸易额：">{{ item.amounts |priceFilterNum}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同数：">{{ item.pcbCount }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="可用余额：">
              {{
              item.accountBalance|priceFilterNum
              }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        border
        ref="tableRef"
        :data="item.orderContractStockupPurchasesVoList"
        tooltip-effect="dark"
        max-height="378"
        :header-cell-style="tableHeader"
      >
        <el-table-column show-overflow-tooltip prop="ocspCode" label="采购计划编号" width="110px"></el-table-column>
        <el-table-column show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
        <el-table-column show-overflow-tooltip prop="seriesName" label="系列" width="110px"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proName" label="产品名称" width="110px"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proType" label="型号" width="110px"></el-table-column>
        <el-table-column prop="orderNumber" label="订货号"></el-table-column>
        <el-table-column prop="cbUnit" label="单位"></el-table-column>
        <el-table-column prop="stockupCount" label="采购数量"></el-table-column>
        <el-table-column prop="cbPrice" label="单品报价"></el-table-column>
        <el-table-column prop="cbTotal" label="报价总额"></el-table-column>
        <el-table-column prop="cbExtype" label="类型"></el-table-column>
        <el-table-column prop="cbExtimeValue"  width="140px" label="货期"></el-table-column>
        <el-table-column show-overflow-tooltip prop="deliveryTime" label="预计发货时间" width="120px">
          <template slot-scope="scope">
            <div>{{ scope.row.deliveryTime | dateFilter }}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createDate" label="计划生成时间" width="120px">
          <template slot-scope="scope">
            <div>{{ scope.row.createDate | dateFilter }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { formatDate } from '@/util/tool'
export default {
  props: ['data'],
  data () {
    return {
      status: ['平台渠道', '供应商', '厂家', '经销商'],

      dataList: [
        '待审核',
        '审核中',
        '履行中',
        '已履行',
        '审核通过待签署',
        '已作废',
        '审核不通过',
        '审核驳回'
      ]
    }
  },

  methods: {
    supplierName (val) {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: val }
      })
    },
    createContract (val) {
      if (
        this.dataList[val.contractState - 1] === '履行中' ||
        this.dataList[val.contractState - 1] === '已履行'
      ) {
        this.$router.push({
          name: 'contractDetails',
          query: {
            type: this.dataList[val.contractState - 1],
            pcbId: val.pcbId
          }
        })
      } else {
        this.$router.push({
          name: 'createContract',
          query: { type: this.dataList[val.contractState - 1], pcbId: val.pcbId }
        })
      }
    },

    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  },
  filters: {
    dateFilter
  }
}

function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
